const TimelinePlayer = () => {
    return (
        <div className="w-full h-full flex justify-center items-center text-white">
            <h1>TimelinePlayer</h1>
        </div>
    )
}

export default TimelinePlayer;